import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import InputGroup from '../InputGroup';
import AsyncSelect from 'react-select/async';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const customStyles = {
  control: base => ({ ...base, fontFamily: 'Roboto, Helvetica, Arial, sans-serif' }),
  container: provided => ({ ...provided, marginTop: 8 }),
  menu: provided => ({ ...provided, marginTop: 1, fontFamily: 'Roboto, Helvetica, Arial, sans-serif', zIndex: 9999 })
};

const useStyles = makeStyles(() => ({
  arrowIcon: { color: 'rgba(0, 0, 0, 0.54)' },
  error: {
    color: '#e53935',
    margin: '8px 12px 0',
    fontSize: 11,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1em',
  }
}));

const AsyncMultiSelect = ({ label, onChange, loadOptions, value, isRequired, error, helperText, disabled, placeholder = "Digite para buscar..." }) => {
  const classes = useStyles();

  const DropdownIndicator = () => (<ArrowDropDownIcon className={classes.arrowIcon}/>);
  const IndicatorSeparator = () => '';

  return (
    <InputGroup label={label} isRequired={isRequired}>
      <AsyncSelect
        cacheOptions
        defaultOptions={false} 
        loadOptions={loadOptions}
        isMulti
        components={{ DropdownIndicator, IndicatorSeparator }}
        styles={customStyles}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        noOptionsMessage={({ inputValue }) => !inputValue ? "Digite para pesquisar" : "Nenhum resultado encontrado"}
        loadingMessage={() => "Buscando..."}
        isDisabled={disabled}
        closeMenuOnSelect={false}
      />
      {error && (
        <p className={classes.error}>{helperText || 'O Campo é obrigatório'}</p>
      )}
    </InputGroup>
  );
};

AsyncMultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired, // Função que busca no backend
  value: PropTypes.array,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default AsyncMultiSelect;